import React from "react";
import { NavLink } from "react-router-dom";
import "./HelpSidebar.css";

const HelpSidebar = () => {
  const links = [
    { path: "/help/faqs", label: "FAQs" },
    { path: "/help/cancellations", label: "Cancellations" },
    { path: "/help/payments", label: "Payment Methods" },
    { path: "/help/booking-details", label: "Booking Details" },
    { path: "/help/communications", label: "Communications" },
    { path: "/help/room-types", label: "Room Types" },
    { path: "/help/pricing", label: "Pricing" },
    { path: "/help/policies", label: "Property Policies" },
    { path: "/help/facilities", label: "Facilities" },
    { path: "/help/security", label: "Security & Awareness" },
    { path: "/help/privacy-policy", label: "Privacy Policy" },
    { path: "/help/trust-safety", label: "Trust & Safety" },
    { path: "/help/guest-policy", label: "Guest Policy" },
  ];

  return (
    <div className="helpSidebar">
      <ul>
        {links.map((link) => (
          <li key={link.path}>
            <NavLink
              to={link.path}
              className={({ isActive }) =>
                isActive ? "activeLink" : "inactiveLink"
              }
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HelpSidebar;
